module.exports = __webpack_public_path__ + "static/media/homeLogo-sm.6c052595.png";